import type { IconData } from '@stacksjs/iconify-core'

export const businessProductsBag1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 10.67H32v15.24h-1.53ZM9.14 25.91h21.33v1.52H9.14Zm18.29-12.19h1.52v3.04h-1.52Zm-3.05 0h3.05v-1.53h-6.1v1.53h-1.52v3.04h1.52v1.53h6.1v-1.53h-3.05zM9.14 9.15v1.52h21.33V9.15H25.9V6.1h-1.52v3.05zm1.52 13.71h9.15v1.52h-9.15Zm0-3.05h4.58v1.53h-4.58Zm-1.52-9.14H7.62v10.67h-6.1v1.52h6.1v3.05h1.52zm-7.62-6.1h22.86V6.1H1.52ZM0 6.1h1.52v15.24H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default businessProductsBag1
